import Auth from '@/middleware/auth';
import Api from '@/middleware/api';
import Vue from 'vue';

const apiHelper = new Api();
const authHelper = new Auth();
const eventHelper = new Vue();

export { apiHelper, authHelper, eventHelper };
